import Box from '@/components/UI/box/Box';
import { useRouter } from 'next/router';
import { memo } from 'react';
import Button from '@/components/UI/button/Button';
import SortingMobileDrawer from './sortingMobileDrawer/SortingMobileDrawer';
import useDrawer from '@/hooks/useDrawer';
interface SortingMenuMobileProps {
  handleSort: (index: number) => void;
}
const list: {
  label: string;
  index: number;
}[] = [{
  label: 'محبوب‌ترین',
  index: 5
}, {
  label: 'ارزان‌ترین',
  index: 3
}, {
  label: 'گران‌ترین',
  index: 2
}];
const SortingMenuMobile = ({
  handleSort
}: SortingMenuMobileProps) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const router = useRouter();
  const handleToggle = () => drawerOpen('SORTING');
  const handleClick = index => () => {
    handleSort(index);
  };
  return <>
      <Box data-sentry-element="Box" data-sentry-source-file="SortingMenuMobile.tsx">
        <Button format="text" onClick={handleToggle} startIcon="arrow-3" size="small" data-sentry-element="Button" data-sentry-source-file="SortingMenuMobile.tsx">
          {list.find(item => item.index === Number(router.query?.sortBy))?.label || 'مرتب‌سازی'}
        </Button>
      </Box>
      <SortingMobileDrawer open={isDrawerOpen('SORTING')} handleClose={drawerClose} handleClick={handleClick} list={list} data-sentry-element="SortingMobileDrawer" data-sentry-source-file="SortingMenuMobile.tsx" />
    </>;
};
export default memo(SortingMenuMobile);